import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface AlertCircleIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const AlertCircleIcon: React.FC<AlertCircleIconProps> = ({
  width = 56,
  height = 56,
  fill = '#D97706'
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={56} height={56} rx={28} fill="white" />
      <path
        d="M28 24V28M28 32H28.01M38 28C38 33.5228 33.5228 38 28 38C22.4772 38 18 33.5228 18 28C18 22.4772 22.4772 18 28 18C33.5228 18 38 22.4772 38 28Z"
        stroke={fill}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);
export { AlertCircleIcon };
